import React from 'react';
import cs from 'classnames';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Flex } from 'shared/components/display';
import styles from './styles';

interface Props {
  text: string;
  disabled?: boolean;
  className?: string;
}

const CheckboxDisplay: React.FC<Props> = ({ text, className, disabled }) => {
  return (
    <Flex
      css={styles}
      className={cs('checkbox-display', className, {
        'checkbox-display--disabled': disabled,
      })}
    >
      {disabled ? (
        <div className="checkbox-display__check--disabled" />
      ) : (
        <FontAwesomeIcon icon={faSquareCheck} size="lg" className="checkbox-display__check" />
      )}
      {text}
    </Flex>
  );
};

export default CheckboxDisplay;
